import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["shape", "size", "use"];
import PropTypes from 'prop-types';
import styled from 'styled-components';
import themePropType from '../utils/themePropType';
import { interactionPropTypes } from '../utils/types';
import * as IconButtonUses from './constants/IconButtonUses';
import { CIRCLE, DEFAULT } from './constants/IconButtonShapes';
import { MEDIUM, EXTRA_SMALL, SMALL } from '../constants/sizes';
import { forwardRef } from 'react';
import { iconButtonTheme } from './theme/iconButtonTheme';
import mergeThemeStyles from '../theme/mergeThemeStyles';
import { jsx as _jsx } from "react/jsx-runtime";
const AbstractVizExIconButton = styled.button.withConfig({
  displayName: "VizExIconButton__AbstractVizExIconButton",
  componentId: "m5a11i-0"
})(["", ""], ({
  theme
}) => mergeThemeStyles({
  component: 'IconButton',
  defaultStyles: iconButtonTheme,
  theme
}));
const VizExIconButton = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      shape = DEFAULT,
      size = MEDIUM,
      use = IconButtonUses.PRIMARY
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(AbstractVizExIconButton, Object.assign({
    shape: shape,
    size: size,
    use: use,
    ref: ref
  }, rest));
});
VizExIconButton.displayName = 'VizExIconButton';
VizExIconButton.propTypes = Object.assign({
  children: PropTypes.node,
  onClick: PropTypes.func,
  shape: PropTypes.oneOf([CIRCLE, DEFAULT]),
  size: PropTypes.oneOf([EXTRA_SMALL, SMALL, MEDIUM]),
  theme: themePropType,
  use: PropTypes.oneOf(Object.values(IconButtonUses))
}, interactionPropTypes);
export default VizExIconButton;